import React, { Component, lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { RouteWrapper } from 'components/layout/helper';
import { ROUTES, PAGE_VIEW_EVENTS } from 'configs/routes/constants';
import withSuspense from 'hoc/withSuspense';
import { TABS } from 'modules/salesManager/constants';

const SalesManager = lazy(() => import('./SalesManager'));

class SalesManagerIndex extends Component {
  render() {
    return (
      <Switch>
        <RouteWrapper
          path={ROUTES.SALES}
          track={PAGE_VIEW_EVENTS.SALES}
          render={withSuspense(SalesManager)}
        />
        <RouteWrapper
          path={ROUTES.FREE_SIGNUP}
          track={PAGE_VIEW_EVENTS.SALES}
          render={() => (
            <Redirect
              to={{
                pathname: ROUTES.SALES,
                state: { tabIndex: TABS.SALES_INFO }
              }}
            />
          )}
        />
      </Switch>
    );
  }
}

export default SalesManagerIndex;
